import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

interface StepBlockProps {
  part: string;
  stepLabel: string;
  text: ReactNode;
  image: string;
}

export const StepBlock = ({ part, stepLabel, text, image }: StepBlockProps) => (
  <div
    className={cn(
      "flex w-full flex-col gap-6",
      "md:flex-row md:items-center md:justify-between md:gap-12"
    )}
  >
    {/* LEFT TEXT BLOCK */}
    <div className="flex-1 gap-2">
      {/* Верхняя строка: Часть + шаг */}
      <div className="fs-300 flex items-center gap-3 font-semibold">
        <span className="text-neutral-100">{part}</span>
        <span className="text-neutral-200/61">{stepLabel}</span>
      </div>

      {/* Основной текст шага */}
      <h4 className="fs-500 text-neutral-100">{text}</h4>
    </div>

    {/* RIGHT IMAGE BLOCK */}
    <div className="flex flex-1 justify-center">
      <img
        src={image}
        alt=""
        className="rounded-mds w-full object-cover md:object-contain"
      />
    </div>
  </div>
);
